import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { MatSnackBar } from "@angular/material/snack-bar";
import { GlobalApp } from "../../tools/global";
import { SubscriptionService } from "../../api/services/subscription.service";
import { UserPreferencesService } from "../../api/services/user-preferences.service";
import { AdmEmailPreference } from "../../api/models/adm-email-preference";

// The key of the ADM update-email preference (UserPreferenceKeys.AdmEmailUpdated on the server) and the kind of entity
// it is set on (UserPreferenceScopes.AdmLayout).
const ADM_EMAIL_KEY = "adm.email.updated";
const ADM_SCOPE = "AdmLayout";

// "Preferences" - the user's own settings, one section per area so more can be added later. For now: which ADMs email them
// when they finish updating (on by default; turning one off stores a row, turning it back on removes it).
@Component({
  selector: "app-preferences",
  templateUrl: "./preferences.component.html",
})
export class PreferencesComponent implements OnInit {
  public loadingData = true;
  public admPreferences: AdmEmailPreference[] = [];
  // ADMs with a save in flight, so a toggle can't be changed twice at once.
  public saving = new Set<number>();

  constructor(
    private app: GlobalApp,
    private router: Router,
    private subscriptionService: SubscriptionService,
    private preferencesService: UserPreferencesService,
    private snackBar: MatSnackBar
  ) {
    this.app.getAuthorizationStatus().subscribe((result) => {
      if (!result.isValid) {
        this.app.logOut();
        this.router.navigate(["login"]);
      } else {
        this.app.initialRefreshUserState(this.subscriptionService);
      }
    });
  }

  ngOnInit() {
    this.loadAdmPreferences();
  }

  loadAdmPreferences() {
    this.loadingData = true;
    this.preferencesService.userPreferencesGetAdmEmailPreferences().subscribe({
      next: (preferences) => {
        this.admPreferences = preferences || [];
        this.loadingData = false;
      },
      error: () => {
        this.loadingData = false;
        this.snackBar.open("Unable to load your preferences.", "Close", { duration: 5000 });
      },
    });
  }

  setAdmEmail(preference: AdmEmailPreference, enabled: boolean) {
    const previous = preference.emailOnUpdate;
    preference.emailOnUpdate = enabled;
    this.saving.add(preference.admLayoutId);

    this.preferencesService
      .userPreferencesSet({ key: ADM_EMAIL_KEY, scopeType: ADM_SCOPE, scopeId: preference.admLayoutId, value: enabled ? "true" : "false" })
      .subscribe({
        next: () => this.saving.delete(preference.admLayoutId),
        error: () => {
          preference.emailOnUpdate = previous;
          this.saving.delete(preference.admLayoutId);
          this.snackBar.open("Unable to save that change. Please try again.", "Close", { duration: 5000 });
        },
      });
  }
}
